import { mockApp } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  {mockApp.title}
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  {mockApp.description}
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs md:text-sm text-foreground-500 mb-6">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-apple-line text-base text-foreground-700"></i>
                    iOS {mockApp.iosVersion}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-android-line text-base text-foreground-700"></i>
                    Android {mockApp.androidVersion}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-download-cloud-line text-base text-foreground-700"></i>
                    {mockApp.size}
                  </span>
                </div>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <button className="px-6 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-apple-fill mr-1.5"></i> App Store 下载
                  </button>
                  <button className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-android-fill mr-1.5"></i> Android 下载
                  </button>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="w-40 h-40 md:w-48 md:h-48 bg-background-100 rounded-2xl flex items-center justify-center border border-background-200/70">
                  <div className="text-center p-4">
                    <i className="ri-qr-code-line text-5xl md:text-6xl text-foreground-400"></i>
                    <p className="text-xs text-foreground-400 mt-2">扫码下载</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}